
<style>
#app{
}
.headersearchbox{
  width: 100vw;
  height: 50px;
  display: flex;
  align-items: center;
  /*background: red;*/
  background-color: #d9d9d9;
}
.mint-searchbar-core {
  -webkit-appearance: none!important;
  -moz-appearance: none!important;
  appearance: none!important;
  border: 0!important;
  -webkit-box-sizing: border-box!important;
  box-sizing: border-box!important;
  width: 100%!important;
  height: 100%!important;
  outline: 0!important;
}

element.style {
}
input[type=search] {
  /* font-size: 16px; */
  /* -webkit-box-sizing: border-box; */
  /* box-sizing: border-box; */
  /* height: 34px; */
  /* text-align: center; */
  /* border: 0; */
  /* border-radius: 6px; */
  /* background-color: rgba(0,0,0,.1); */
}
input[type=color], input[type=date], input[type=datetime-local], input[type=datetime], input[type=email], input[type=month], input[type=number], input[type=password], input[type=search], input[type=tel], input[type=text], input[type=time], input[type=url], input[type=week], select, textarea {
  /* line-height: 21px; */
  /* width: 100%; */
  /* height: 40px; */
  /* margin-bottom: 15px; */
  /* padding: 10px 15px; */
  /* -webkit-user-select: text; */
  /* border: 1px solid rgba(0,0,0,.2); */
  /* border-radius: 3px; */
  /* outline: 0; */
  /* background-color: #fff; */
  /* -webkit-appearance: none; */
}
.mint-searchbar-core {
  -webkit-appearance: none!important;
  -moz-appearance: none!important;
  appearance: none!important;
  border: 0!important;
  -webkit-box-sizing: border-box!important;
  box-sizing: border-box!important;
  width: 100%!important;
  height: 100%!important;
  outline: 0!important;
}
.mint-searchbar-core {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border: 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  outline: 0;
}
input, select, textarea {
  font-family: 'Helvetica Neue',Helvetica,sans-serif!important;
  font-size: 17px!important;
  -webkit-tap-highlight-color: transparent!important;
  -webkit-tap-highlight-color: transparent!important;
}
input {
  line-height: normal!important;
  text-align: start!important;
  background: #fff!important;
  padding: 1px 2px!important;

}
button, input, optgroup, select, textarea {
  font: inherit!important;
  margin: 0!important;
  margin-top: 0px!important;
  margin-right: 0px!important;
  margin-bottom: 0px!important;
  margin-left: 0px!important;
  color: inherit!important;
}
</style>
<template>
  <div>
    <mt-search style="position: fixed;z-index: 1;width: 100%; top: 40px;" v-model="searchValue">
    </mt-search>
    <div class="hallContainer" :style="{height: wrapperHeight + 'px'}">
      <div class="mui-card" :style="{height:cardHeight + 'px'}" v-if="taskList.length > 0 && loadDone">
        <mt-loadmore :bottom-method="loadBottom" @bottom-status-change="handleBottomChange" :bottom-all-loaded="allLoaded" :auto-fill="false" ref="loadmore">
          <ul class="mui-table-view mui-table-view-chevron">
          <li class="mui-table-view-cell mui-collapse" v-for="(item, index) in taskList" :key="index" :class="{'mui-active': navIndex === index}">
            <a class="mui-navigate-right" @click="handleClick(index)" :href="item.building.childbuildinglist.length === 0 ? '/Build/buildDetail/' + item.id + '/' + item.building_id : null">
              <div class="mui-media-left">
                <img v-if="item.building.buildingimg" class="mui-media-object mui-pull-left" :src="process.env.BASE_URL + item.building.buildingimg">
                <img v-else class="mui-media-object mui-pull-left" src="/static/images/avatar.png">
                <span class="mui-icon-extra mui-icon-extra-peoples mui-badge mui-badge-primary">{{item.current }}</span>
              </div>
              <div class="mui-media-body" >
                <div class="mui-media-body-first">
                  {{ item.building.name }}
                </div>
                <div class="mui-media-body-second">
                  <div class="mui-media-body-second-left">{{ item.building.address }}</div>
                  <div class="mui-media-body-second-right">
                    <a :href="'http://api.map.baidu.com/marker?location=' + item.building.lat + ',' + item.building.lng + '&title=' +  item.building.name + '&content=' +  item.building.name + '&output=html'" @click.stop>
                      <img src="/static/images/nav_icon.png" alt="" style="width: 14px">
                    </a>
                  </div>
                </div>
                <div class="mui-media-body-third">
                 <span class="mui-progressbar mui-progressbar-danger mui-media-body-third" data-progress="50">
                  {{ item.completerate }}%
                <span
                  :style="'transform: translate3d(-'+ (100 - item.completerate) +'%, 0px, 0px); opacity: 0.6'"></span>
                </span>
                </div>
              </div>
            </a>





            <!--子页面的获取-->
            <ul class="mui-table-view mui-table-view-chevron">
              <li class="mui-table-view-cell mui-media" v-for="(childItem , childIndex) in item.building.childbuildinglist" :key="childIndex">
                <router-link class="mui-navigate-right" :to="'/Build/buildDetail/'+ item.id + '/' + childItem.id">
                  <div class="mui-media-body">
                    <div class="mui-media-body-left">
                      {{ childItem.name }}
                    </div>
                    <div class="mui-media-body-right">
                    <span class="mui-progressbar mui-progressbar-danger" data-progress="50">
                      {{ childItem.childcomplaterate }} %
                     <span :style="'transform: translate3d(-'+ (100 - childItem.childcomplaterate) +'%, 0px, 0px); opacity: 0.6'"></span>
                    </span>
                    </div>
                  </div>
                </router-link>
              </li>
            </ul>


          </li>
        </ul>



          <div v-if="allLoaded" style="text-align:center;" class="data-none">没有更多数据了</div>
          <div slot="bottom" class="mint-loadmore-bottom">
            <span v-show="bottomStatus !== 'loading'" :class="{ 'is-rotate': bottomStatus === 'drop' }">↑</span>
            <span v-show="bottomStatus === 'loading'">
              <mt-spinner v-show="bottomStatus === 'loading'" color="#26a2ff"></mt-spinner>
            </span>
          </div>
        </mt-loadmore>
      </div>
      <div class="loading-overlay" v-if="isLoading">
        <div class="loading-message">正在加载...</div>
      </div>
      <div v-if="taskList.length == 0 && loadDone">暂无数据</div>
      <div class="nowLoading" v-if="!loadDone">正在加载中，请稍后。。。</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HallContainer.vue',
  data () {
    return {
      isLoading:false,
      showCard: false,
      xxx: 0,
      navIndex: -1,
      title: '数据采集',
      showPopup: false,
      searchValue: '',
      taskList: [],
      allLoaded: false,
      wrapperHeight: document.documentElement.clientHeight - 44 || document.body.clientHeight - 44,
      offset: 0,
      limit: 10,
      InitialLoading: true,
      bottomStatus: '',
      loadDone: false,//页面加载完毕
      cardHeight: document.documentElement.clientHeight - 154 || document.body.clientHeight - 154,//卡片区域高度
    }
  },
  created () {
    setTimeout(() => {
      this.showCard = true
    }, 530)
    this.$emit('getTitle', this.title)
    this.getTaskList(this.offset, this.limit)
  },
  methods: {
    handleClick (index) {
      if (this.navIndex === index) {
        this.navIndex = -1
      } else {
        this.navIndex = index
      }
    },
    getTaskList (offset, limit) {
      this.isLoading=true
      let select = {
        offset: offset,
        limit: limit
      }

      if (this.searchValue !== '') {
        select['name'] = this.searchValue
      }

      this.$http.post('api/gather/getMyTask', select, {emulateJSON: true})
        .then(function (data) {
          this.loadDone = true;
          if (offset === 0) {
            this.taskList = data.body.data.list
          } else {
            for (let i = 0; i < data.body.data.count; i++) {
              this.taskList.push(data.body.data.list[i])
            }
          }
          if (data.body.data.count < this.limit) {
            this.allLoaded = true
          }
          this.isLoading=false
        })
    },
    loadBottom () {
      this.handleBottomChange('loading')
      this.offset += this.limit
      this.getTaskList(this.offset, this.limit)
      setTimeout(() => {
        this.handleBottomChange('loadingEnd')
      }, 3000)
      this.$refs.loadmore.onBottomLoaded()
    },
    handleBottomChange (status) {
      this.bottomStatus = status
    }
  },
  watch: {
    searchValue (n) {
      this.offset = 0
      this.limit = 10
      this.getTaskList(this.offset, this.limit)
    }
  }
}
</script>

<style scoped lang="scss">
.mui-card{
  overflow: scroll;
  padding-bottom: 20px;
}
.mui-card-footer img{
  width: 15%;
}
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.loading-message {
  color: white;
  font-size: 18px;
}


.hallContainer{
  padding-top: 40px;
  // margin-bottom: 60px;
}

#add-button{
  position: fixed;
  margin: 10px;
  width: 95%;
  bottom: 50px;
  .mui-btn{
    width: 100%;
  }
}

.li {
  display: inline-block;
  position: relative;
  overflow: hidden;
  padding: 11px 15px;
  .navBox-li-line {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 2px;
    background: #08568d;
  }
}
.li-activate {
  display: inline-block;
  position: relative;
  overflow: hidden;
  padding: 11px 15px;
  color: #08568d;
}

.mui-table-view-cell.mui-active{
  background-color: #CCC;
}

.mui-table-view{
  .mui-table-view-cell{
    .mui-navigate-right{
      height: 100px;
      .mui-media-left{
        width: 40px;
        height: 78px;
        display: inline-block;
        text-align: center;
        float: left;
        img{
          width: 100%;
        }
        span{
          width: 40px;
          text-align: center;
          font-size: 16px;
          margin: 10px auto;
        }
      }
      .mui-media-body{
        width: calc(100% - 70px);
        display: inline-block;
        padding-left: 20px;
        height: 78px;
        float: left;
        .mui-media-body-first{
          width: 100%;
          overflow:hidden;
          text-overflow:ellipsis;
          line-height: 28px;
          font-size: 20px;
        }
        .mui-media-body-second{
          width: 100%;
          .mui-media-body-second-left{
            max-width: 90%;
            display: inline-block;
            font-size: 14px;
            line-height: 18px;
            overflow:hidden;
            text-overflow:ellipsis;
          }
          .mui-media-body-second-right{
            max-width: 10%;
            display: inline-block;
          }
        }
        .mui-media-body-third{
          height: 22px;
          display: inline-block;
          float: left;
          width: 100%;
          text-align: center;
        }
      }
    }
    .mui-table-view{
      background-color: #EFEFEF;
      .mui-table-view-cell{
        padding-left: 20px;
        .mui-navigate-right{
          height: 60px;
          .mui-media-body{
            width: 100%;
            height: 37px;
            .mui-media-body-left{
              width: 40%;
              float: left;
              font-size: 16px;
              line-height: 26px;
              padding-top: 5px;
              display: inline-block;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            .mui-media-body-right{
              width: 50%;
              display: inline-block;
              padding-top: 5px;
              .mui-progressbar{
                height: 26px;
                display: inline-block;
                float: left;
                text-align: center;
                line-height: 26px;
              }
            }
          }
        }
      }
    }
  }
}

.mui-table-view-chevron .mui-table-view-cell {
  padding-right: 57px;
}

.mui-badge, .mui-badge-primary{
  float: left;
  margin-top: 10px;
  font-size: 14px;
}

.mint-search{
  height: 40px;
  padding: 0;
  .mint-searchbar{
    padding: 0;
  }

}

.mint-searchbar-inner{
  padding: 0;
  height: 60px;
}

.mint-searchbar{
  padding: 0;
}

.mint-searchbar-cancel{
  height: 50px;
  line-height: 40px;
  background: white;
  margin: 0;
  padding: 5px;
}
.nowLoading{
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/tabbar/HallContainer.vue